import React from 'react';

const ShelterCareConnectLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { icon: 'w-12 h-12', text: 'text-lg' },
    md: { icon: 'w-16 h-16', text: 'text-xl' },
    lg: { icon: 'w-24 h-24', text: 'text-3xl' },
    xl: { icon: 'w-32 h-32', text: 'text-4xl' }
  };

  const currentSize = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* New Shelter Care Connect Logo */}
      <div className={`${currentSize.icon} relative bg-white rounded-lg p-1 shadow-lg`}>
        <img
          src="/shelter-logo.jpg"
          alt="Shelter Care Connect Logo"
          className="w-full h-full object-contain rounded"
          onError={(e) => {
            console.log("Local logo failed, trying fallback");
            // Fallback to external URL if local image fails
            e.target.src = "https://customer-assets.emergentagent.com/job_care-system-4/artifacts/120mm0sf_logo-7.jpg";
          }}
          onLoad={() => console.log("Logo loaded successfully")}
        />
      </div>

      {/* Brand Text */}
      {showText && (
        <div className="flex flex-col">
          <h1 className={`${currentSize.text} font-bold leading-tight ${
            className.includes('text-white') ? 'text-white' : 'text-gray-900'
          }`}>
            Shelter Care Connect
          </h1>
          {size === 'lg' || size === 'xl' ? (
            <p className={`text-sm leading-tight ${
              className.includes('text-white') ? 'text-gray-200' : 'text-gray-600'
            }`}>
              Where Compassion Meets Technology
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default ShelterCareConnectLogo;